import {useMemo} from 'react';
import {useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {getUserPaymentMethods} from 'store/user/user-selectors';
import {PAYPAL_WALLET_VALUE} from 'utils/user-utils';
import {CARD_FIELD, ADD_NEW_CARD_VALUE, NAME_FIELD} from './index';

export const useDefaultCard = () => {
    const cards = useSelector(getUserPaymentMethods);

    const initialSelectedCardValue = useMemo(() => {
        let defaultCard = cards.find(card => card.isDefault);

        if (!defaultCard) {
            defaultCard = cards.find(
                card => card.wallet === PAYPAL_WALLET_VALUE
            );
        }

        if (!defaultCard) {
            defaultCard = cards[0];
        }

        return defaultCard;
    }, [cards]);

    return initialSelectedCardValue;
};

const usePaymentForm = () => {
    const initialSelectedCardValue = useDefaultCard();

    return useForm({
        defaultValues: {
            [CARD_FIELD]:
                initialSelectedCardValue?.externalId || ADD_NEW_CARD_VALUE,
            [NAME_FIELD]: '',
        },
    });
};

export default usePaymentForm;
